export default "__VITE_ASSET__WJ64g40k__"